/**
 * GeofenceRulesHint — footer cross-link shown at the bottom of every
 * geofence scope page (Department / Group / Worker).
 *
 * Geofences define WHERE the work area is, but the on/off ENFORCEMENT
 * switch ("Require GPS" / "Enforce work-area boundary") lives on the
 * Attendance Rules page. Workers/admins kept missing that the fence they
 * drew wasn't enforced because the toggle is elsewhere — this footer makes
 * the relationship explicit and jumps straight there. The Rules page has a
 * reciprocal link back to Geofences.
 */
import React from 'react';
import { Alert, Box, Button, Typography } from '@mui/material';
import { RuleOutlined } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const GeofenceRulesHint: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  return (
    <Alert
      severity="info"
      variant="outlined"
      icon={false}
      sx={{ width: '100%', mt: 2, '& .MuiAlert-message': { width: '100%' } }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 1.5, flexWrap: 'wrap' }}>
        <Typography variant="body2" sx={{ fontSize: '0.8rem', color: 'text.secondary' }}>
          {t('attendance:geofences.enforcementHintText')}
        </Typography>
        <Button
          size="small"
          startIcon={<RuleOutlined sx={{ fontSize: 16 }} />}
          onClick={() => navigate('/attendance/rules/global')}
          sx={{ borderRadius: 1, textTransform: 'none', fontSize: '0.8rem', whiteSpace: 'nowrap' }}
        >
          {t('attendance:geofences.enforcementHintCta')}
        </Button>
      </Box>
    </Alert>
  );
};

export default GeofenceRulesHint;
